export const quotes = "quotes";
export const policies = "policies";
